import React from 'react';
import { AritoCustomInputTable as InputTable, type GridCellParams } from '@/components/custom/erp';
import InputTableActionBar from './InputTableActionBar';
import { SelectedCellInfo } from './useInputTableRow';
import { getInputTableColumns } from './cols';
import type { FormMode } from '@/types/form';

interface InputTableTabProps {
  mode: FormMode;
  rows: any[];
  selectedRowUuid?: string | null;
  selectedCell?: SelectedCellInfo | null;
  onRowClick?: (params: any) => void;
  onCellClick?: (params: GridCellParams) => void;
  onAddRow: () => void;
  onDeleteRow: () => void;
  onCopyRow: () => void;
  onPasteRow: () => void;
  onMoveRow: (direction: 'up' | 'down') => void;
  onCellValueChange: (rowUuid: string, field: string, newValue: any) => void;
}

const InputTableTab: React.FC<InputTableTabProps> = ({
  mode,
  rows,
  selectedRowUuid,
  onRowClick,
  onAddRow,
  onDeleteRow,
  onCopyRow,
  onPasteRow,
  onMoveRow,
  onCellValueChange
}) => {
  return (
    <InputTable
      rows={rows}
      className='h-[330px]'
      onRowClick={onRowClick}
      selectedRowId={selectedRowUuid || undefined}
      columns={getInputTableColumns(onCellValueChange)}
      getRowId={(row: any) => row?.uuid || ''}
      actionButtons={
        <InputTableActionBar
          mode={mode}
          handleAddRow={onAddRow}
          handleDeleteRow={onDeleteRow}
          handleCopyRow={onCopyRow}
          handlePasteRow={onPasteRow}
          handleMoveRow={onMoveRow}
        />
      }
    />
  );
};

export default InputTableTab;
